/*
 * This program is part of the OpenCms Apollo Template.
 *
 * Copyright (c) Alkacon Software GmbH & Co. KG (http://www.alkacon.com)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { _OpenCmsReinitEditButtons } from './script-opencms-callbacks.js';

 // the global objects that must be passed to this module
var jQ;
var DEBUG;

// all initialized lists by unique instance id
var m_lists = {};

// all initialized list archive filters by unique instance id
var m_archiveFilters = {};

// groups of lists by element id (potentially more then one on a page)
var m_listGroups = {};

// groups of archive filters lists by list element id (potentially more then one on a page)
var m_archiveFilterGroups = {};

// all auto loading lists as array for easy iteration
var m_autoLoadLists = [];

function calculateStateParameter(filter, liId) {
    var value = $( 'li#' + liId).data("value")
    var paramkey = liId.startsWith('cat_') ? filter.catparamkey : filter.archiveparamkey;
    var stateParameter =
        typeof paramkey != 'undefined' && paramkey != '' && typeof value != 'undefined' && value != ''
            ? '&' + paramkey + '=' + value
            : '';
    return stateParameter;
}

function splitRequestParameters(paramstring) {
    var params={};
    paramstring.replace(/[?&]*([^=&]+)=([^&]*)/gi, function(str,key,value) {
        params[key] = value;
    });
    return params;
}

// retrieves the set filters from other category filters and combines the filter parameters
function getAdditionalCategoryFilterParams(filter) {
    var filterGroup = m_archiveFilterGroups[filter.elementId];
    var params = "";
    if (typeof filterGroup != 'undefined') {
        for (var i=0; i<filterGroup.length; i++) {
            var fi = filterGroup[i];
            if (fi.combinable && fi.id != filter.id) {
                fi.$element.find("li.active").each( function() {
                    var p = calculateStateParameter(fi, this.id);
                    params += p;
                });
            }
        }
    }
    return params;
}

function listFilter(id, triggerId, filterId, searchStateParameters, removeOthers) {

    if (DEBUG) console.info("listFilter() called elementId=" + id);

    // reset filters of not sorting
    var filterGroup = m_archiveFilterGroups[id];
    var filter = m_archiveFilters[filterId]
    var removeAllFilters = !(filter && filter.combinecategories);
    if ((triggerId != "SORT") && (typeof filterGroup != "undefined")) {
        // potentially the same filter may be on the same page
        // here we make sure to reset them all
        for (i=0; i<filterGroup.length; i++) {
            var fi = filterGroup[i];
            // remove all active / highlighted filters
            // unless filters should be combined
            var $liactive = fi.$element.find("li.active");
            if (removeOthers && (removeAllFilters || !fi.combinable || fi.id == filterId)) {
                $liactive.removeClass("active");
            }
            fi.$element.find("li.currentpage").removeClass("currentpage");
            if (triggerId != null) {
                // activate / highlight clicked filter
                fi.$element.find("#" + triggerId).addClass("active");
                fi.$textsearch.val('');
            } else if (fi.id != filterId) {
                // clear text search input in other filter instances
                fi.$textsearch.val('');
            } else if ((typeof searchStateParameters === 'string' || searchStateParameters instanceof String) && searchStateParameters.length > 0) {
                // highlight possibly already checked category restrictions
                var catparamkey = fi.catparamkey;
                   if(typeof catparamkey != 'undefined'){
                    var params = splitRequestParameters(searchStateParameters);
                       var initValue = params[catparamkey];
                       if (typeof initValue != 'undefined' && initValue != '') {
                           fi.$element.find("li").each(function () {
                            var $this = $(this);
                            var itemValue = $this.data("value");
                            if (itemValue === initValue) {
                                $this.addClass("active");
                            }
                        });
                    }
                   }
            }
        }
    }

    var listGroup = m_listGroups[id];
    if (typeof listGroup != "undefined") {
        // required list is an element on this page
        for (var i=0; i<listGroup.length; i++) {
            updateInnerList(listGroup[i].id, searchStateParameters, true);
        }
    } else {
        var archive = m_archiveFilters[filterId];
        // list is not on this page, check filter target attribute
        var target = archive.target;
        if (typeof target != "undefined" && target !== window.location.pathname && target + "index.html" !== window.location.pathname) {
            if (DEBUG) console.info("No list group found on page, trying redirect to " + target);
            var params = splitRequestParameters(searchStateParameters);
            Apollo.post(target, params);
        } else {
            console.error("Unable to load Apollo list!\nNo dynamic list found on the page and property 'apollo.list' not set.");
        }
    }
}

function updateInnerList(id, searchStateParameters, reloadEntries) {
    searchStateParameters = searchStateParameters || "";
    reloadEntries = reloadEntries || false;

    var list = m_lists[id];

    if (DEBUG) console.info("updateInnerList() called instanceId=" + list.id + " elementId=" + list.elementId + " parameters=" + searchStateParameters);

    if (!list.locked) {
        list.locked = true;

        var ajaxOptions = "&";
        if (reloadEntries) {
            // hide the "no results found" message during search
            list.$editbox.hide();
        } else {
            // fade out the load more button
            list.$element.find('.loadMore').addClass("fadeOut");
            // we don't need to calculate facets again if we do not reload all entries
            ajaxOptions = "&hideOptions=true&";
        }

        // calculate the spinner position in context to the visible list part
        var scrollTop = jQ(window).scrollTop();
        var windowHeight = jQ(window).height();
        var elementTop = list.$element.offset().top;
        var elementHeight = list.$element.outerHeight(true);
        var topOffset = Math.max(scrollTop - elementTop, 0);
        var visibleHeight = Math.min(scrollTop + windowHeight, elementTop + elementHeight) - Math.max(scrollTop, elementTop);
        var spinnerPos = (visibleHeight * (reloadEntries ? 0.5 : 0.8)) + topOffset - 15;
        // show the spinner
        list.$spinner.hide().removeClass("fadeOut").addClass("fadeIn").css("top", spinnerPos).show();

        var facetOptions = jQ('#facets_' + list.elementId);
        jQ.get(buildAjaxLink(list, ajaxOptions, searchStateParameters), function(resultList) {

            var $result = jQ(resultList);
            // collect information about the search result
            var resultData = $result.filter('#resultdata').first().data('result');
            if (DEBUG) console.info("Search result: list=" + list.id + ", start=" + resultData.start + ", end=" + resultData.end + ", entries=" + resultData.found + ", pages=" + resultData.pages);

            // append all results from the ajax call to a new element that is not yet displayed
            var $entries = $result.filter(".list-entry");
            var $newPage = jQ('<div class="list-entry-page"></div>');
            $entries.appendTo($newPage);

            // clear the pagination element
            list.$pagination.empty();

            if (reloadEntries) {
                // remove the old entries when list is relaoded
                var $oldPage = list.$entrybox.find(".list-entry-page");
                // set min-height of list to avoid screen flicker
                list.$entrybox.css("min-height", list.$entrybox.height() + 'px');
                $oldPage.remove();
            }

            // add the new elements to the list
            $newPage.appendTo(list.$entrybox);

            // set pagination element with new content
            $result.filter('.list-append-position').appendTo(list.$pagination);

            if (reloadEntries) {
                // reset the list option box
                facetOptions.find(".list-options").remove();
                $result.filter(".list-options").appendTo(facetOptions);

                // check if we have found any results
                if ($entries.length == 0) {
                    // show the "no results found" message
                    list.$editbox.show();
                    // no results means we don't need any pagination element
                    list.$pagination.hide();
                } else {
                    // show the pagination element
                    list.$pagination.show();
                }
                // reset the min-height of the list now that the elements are visible
                list.$entrybox.animate({'min-height': "0px"}, 500);
            }

            // fade out the spinner
            list.$spinner.removeClass("fadeIn").addClass("fadeOut");
            list.locked = false;

            if ((list.appendOption == "clickfirst") && list.notclicked && !reloadEntries) {
                // this is a auto loading list that is activated on first click
                m_autoLoadLists.push(list);
                list.notclicked = false;
                if (m_autoLoadLists.length == 1) {
                    // enable scroll listener because we now have one autoloading gallery
                    jQ(window).bind('scroll', handleAutoLoaders);
                }
                handleAutoLoaders();
            } else if (reloadEntries && list.autoload) {
                // check if we can render more of this automatic loading list
                handleAutoLoaders();
            }

            // reset the OpenCms edit buttons
            _OpenCmsReinitEditButtons();
        });
    }
}


function buildAjaxLink(list, ajaxOptions, searchStateParameters) {

    var params = "?contentpath=" + list.path
        + "&instanceId="
        + list.id
        + "&elementId="
        + list.elementId
        + "&sitepath="
        + list.sitepath
        + "&subsite="
        + list.subsite
        + "&__locale="
        + list.locale
        + "&loc="
        + list.locale;

    var facets = jQ("#facets_" + list.elementId);
    if (facets.length != 0) {
        params = params + "&facets=" + facets.data("facets");
    }
    params = params + "&option=" + list.option;
    return list.ajax + params + ajaxOptions + searchStateParameters;
}


function handleAutoLoaders() {
    if (m_autoLoadLists != null) {
        for (var i=0; i<m_autoLoadLists.length; i++) {

            var list = m_autoLoadLists[i];
            var appendPosition = list.$element.find(".list-append-position");

            if (appendPosition.length
                && !list.locked
                && appendPosition.data("dynamic")
                // NOTE: jQuery.visible() is defined in script-jquery-extensions.js
                && appendPosition.visible()) {

                updateInnerList(list.id, list.$element.find('.loadMore').attr('data-load'), false);
            }
        }
    }
}


/****** Exported functions ******/

export function archiveSearch(id, searchStateParameters) {

    var filter = m_archiveFilters[id];
    listFilter(filter.elementId, null, filter.id, searchStateParameters + filter.$textsearch.val(), true);
}


export function facetFilter(id, triggerId, searchStateParameters) {

    listFilter(id, triggerId, null, searchStateParameters, true);
}


export function archiveFilter(id, triggerId) {

    var filter = m_archiveFilters[id];

    // if filters of other category select boxes should be combined with that one - get the other filters that are set
    var additionalCategoryFilters = filter.combinecategories ? getAdditionalCategoryFilterParams(filter) : "";

    // calculate the filter query part for the just selected item
    var additionalStateParameter = calculateStateParameter(filter, triggerId);

    listFilter(filter.elementId, triggerId, id, filter.searchstatebase + additionalCategoryFilters + additionalStateParameter, true);
}


export function update(id, searchStateParameters, reloadEntries) {

    updateInnerList(id, searchStateParameters, reloadEntries == "true");
}

export function init(jQuery, debug) {

    jQ = jQuery;
    DEBUG = debug;

    if (DEBUG) console.info("ApolloOldList.init()");

    var $listElements = jQ('.ap-list-entries');
    if (DEBUG) console.info(".ap-list-entries elements found: " + $listElements.length);

    if ($listElements.length > 0 ) {
        $listElements.each(function() {

            // initialize lists with values from data attributes
            var $list = jQ(this);

            if (typeof $list.data("list") != 'undefined') {
                // read list data
                var list = $list.data("list");
                // add more data to list
                list.$element = $list;
                list.id = $list.attr("id");
                list.elementId = $list.data("id");
                list.$editbox = $list.find(".editbox");
                list.$entrybox = $list.find(".ap-list-box");
                list.$spinner = $list.find(".spinner");
                list.$pagination = $list.find(".ap-list-pagination");
                list.locked = false;
                list.autoload = false;
                list.notclicked = true;
                if (list.appendSwitch.indexOf(Apollo.gridInfo().grid) >= 0) {
                    // I think this is a cool way for checking the screen size ;)
                    list.option = "append";
                } else {
                    list.option = "paginate";
                }
                if ((list.option == "append") && (list.appendOption == "noclick")) {
                    // list automatically loads in scrolling
                    list.autoload = true;
                    m_autoLoadLists.push(list);
                };
                // store list data in global array
                m_lists[list.id] = list;
                // store list in global group array
                var group = m_listGroups[list.elementId];
                if (typeof group != 'undefined') {
                    group.push(list);
                } else {
                    m_listGroups[list.elementId] = [list];
                }
                if (DEBUG) console.info("List data found: id=" + list.id + ", elementId=" + list.elementId + " option=" + list.option);
            }

            var initParams = "";
            if (typeof list.initparams != "undefined") {
                initParams = list.initparams;
                if (DEBUG) console.info("List data init params: " + initParams);
            }
            // load the initial list
            updateInnerList(list.id, initParams, true);
        });

        if (m_autoLoadLists.length > 0) {
            // only enable scroll listener if we have at least one autoloading gallery
            jQ(window).on('scroll', handleAutoLoaders);
        }
    }

    var $listArchiveFilters = jQ('.ap-list-archive');
    if (DEBUG) console.info(".ap-list-archive elements found: " + $listArchiveFilters.length);

    if ($listArchiveFilters.length > 0 ) {
        $listArchiveFilters.each(function() {

            // initialize filter archives
            var $archiveFilter = jQ(this);

            var filter = $archiveFilter.data("filter");
            filter.$element = $archiveFilter;
            filter.id = $archiveFilter.attr("id");
            filter.elementId = $archiveFilter.data("id");
            filter.$form = $archiveFilter.find("#queryform_" + filter.id);
            filter.$textsearch = $archiveFilter.find("#textsearch_" + filter.id);

            // store filter data in global array
            m_archiveFilters[filter.id] = filter;

            // store filter in global group array
            var group = m_archiveFilterGroups[filter.elementId];
            if (typeof group != 'undefined') {
                group.push(filter);
            } else {
                m_archiveFilterGroups[filter.elementId] = [filter];
            }
            if (DEBUG) console.info("Archive filter data found: id=" + filter.id + ", elementId=" + filter.elementId);

            if (typeof filter.initparams != "undefined" && filter.initparams != "") {
                if (DEBUG) console.info("List data filter init params: " + filter.initparams);
                // highlight filter correctly
                listFilter(filter.elementId, null, filter.id, filter.initparams, false);
            }

        });
    }
}


